import React from "react";
import { Row, Col, Form, Input, TimePicker } from "antd";
import classes from "../Pages.module.css";
import moment from 'moment';

const FormRenderer = (props) => {
  const handleChange = (e, param) => {
    console.log(e.target.value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["accountHeader"]];
      console.log(newdata);

      newdata[0][param] = e.target.value;

      return {
        ...data,
        accountHeader: newdata,
      };
    });
  };

  

  const handleTimeChange = (time, timeString, field) => {
    props.setData((prevData) => {
      const newData = [...prevData["accountHeader"]];
      newData[0][field] = timeString || null;
  
      return {
        ...prevData,
        accountHeader: newData,
      };
    });
  };
  

  return (
    <Row className={classes["RowDE"]}>
      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Shift Description <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Description"
              value={props.data?.shift_desc || ''}
              onChange={(e) => handleChange(e, "shift_desc")}
              bordered={false}
              style={{
                width: "100%",
                backgroundColor: "white",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                In Time <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <TimePicker
              placeholder="Select In Time"
              showNow={false}
              value={props.data?.in_time ? moment(props.data.in_time, 'HH:mm') : null}
              onChange={(time, timeString) => handleTimeChange(time, timeString, "in_time")}
              style={{ width: "100%" }}
              format="HH:mm"
              
            />
          </Form.Item>
        </Form>
      </Col>

      <Col lg={6} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div style={{ padding: "0rem 0.5rem", fontSize: "0.7rem", fontWeight: "bold" }}>
                Out Time <span style={{color:"red" , marginLeft:"1px"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <TimePicker
              placeholder="Select Out Time"
              showNow={false}
              value={props.data.time_out ? moment(props.data.time_out, 'HH:mm') : null}
              onChange={(time, timeString) => handleTimeChange(time, timeString, "time_out")}
              style={{ width: "100%" }}
              format="HH:mm"
             
            />
          </Form.Item>
        </Form>
      </Col>

      <Col span={8} style={{ margin: "auto" }}>
        {props.save && (
          <button
            onClick={(event) => props.handleSubmit(event)}
            className={classes["ProfileButtonF"]}
          >
            Add Record
          </button>
        )}
      </Col>
    </Row>
  );
};

export default FormRenderer;
